import { MDBAlert, MDBCol, MDBRow, MDBAutocomplete } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { createAccContacts, getcustomContactFields, getMisc, updateAccContacts } from '../../../apiclients/streamsapi_bridge';
import { formattedNumber, validatePhoneNumber } from '../phonenumbers/AddRemoveNumbers';
import  {LocAddressSeach} from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from 'react-router';
import { CANADA, USA } from '../../../components/images';


const AddAccContacts = forwardRef(({ onClose, setIsloading, contactInfo, editFlag }, ref) => {
    const { t, i18n } = useTranslation();
    const [internalError, setInternalError] = useState(false);
    const [customFields, setcustomFields] = useState([]);
    const [contactDetails, setcontactDetails] = useState({})
    const [addressReasults, setAddressReasults] = useState([]);
    const [isDisplay, setisDisplay] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const allowAPI = useRef(true);
    const [typingTimeout, setTypingTimeout] = useState(null);
    const [contactType, setContactType] = useState(null)
    const navigate =useNavigate();
    const defaultFormValues = {
        email: "",
        first_name: "",
        last_name: "",
        home_phone: "",
        mobile_phone: "",
        address: "",
        notes: "",
        contact_type: 0,
        office_phone: "",
        nick_name: "",
        location: "",
        alt_email: "",
        company_name: "",
        company_phone: "",
        company_fax: "",
        company_address: "",
        sip_uri: "",
        custom_fields: []
    };
    const { register, formState: { isDirty, dirtyFields, errors }, setError, clearErrors, reset, watch, handleSubmit, setValue, getValues } = useForm({
        defaultValues: defaultFormValues
    });

    useEffect(() => {
        if (!editFlag) {
            reset(defaultFormValues);
            getAllCustomFields();
        }
        getContactType()

    }, [editFlag]);

    useEffect(() => {
        // Cleanup function to clear timeout when component unmounts or input value changes
        return () => {
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
        };
    }, [typingTimeout]);
    async function getContactType() {
        let updates = {};
        updates = {
            misc: ["contacts"]
        };

        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            updates
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const basicInfo = await response.json();
        if (!basicInfo) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
        setContactType(basicInfo.misc.contacts);
    }
    async function getAllCustomFields() {
        try {
            setInternalError(false);
            setIsloading(true);
            console.log(sessionStorage.getItem("admin_session"));
            const response = await getcustomContactFields(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
            setIsloading(false);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            const rawData = await response.json();
            if (!rawData) {
                setInternalError(true);
            }
            console.log("getcustomContactFields data :::::::::: " + JSON.stringify(rawData));
            setcustomFields(rawData?.customFieldsDtls ?? []);
            setTimeout(() => {
                setIsloading(false);
            }, 1000);

        } catch (error) {

        }
    }

    async function handleCustomFields(event, id) {
        event.preventDefault();
        const custom = watch("custom_fields") ?? [];
        const index = custom.findIndex((item) => parseInt(item.id) === parseInt(id));
        let updateCustom = [];
        if (index !== -1) {
            updateCustom = custom.map((item) => parseInt(item.id) === parseInt(id) ? { ...item, value: event.target.value } : item)
        } else {
            updateCustom = [...custom, { id: id, value: event.target.value }]

        }

        setValue("custom_fields", updateCustom, { shouldDirty: true });

    }      
    useEffect(() => {
        if (editFlag && Object.keys(contactInfo).length > 0) {
            // setcontactDetails
            setcustomFields(contactInfo?.custom_fields ?? []);
            reset({
                email: contactInfo?.email ?? "",
                first_name: contactInfo?.first_name ?? "",
                last_name: contactInfo?.last_name ?? "",
                home_phone: contactInfo?.home_phone ?? "",
                mobile_phone: contactInfo?.mobile_phone ?? "",
                address: contactInfo?.address ?? "",
                notes: contactInfo?.notes ?? "",
                contact_type: contactInfo?.contact_type === "Global contact"
                ? 4
                : contactInfo?.contact_type === "Personal contact"
                ? 1
                : 0,
                office_phone: contactInfo?.office_phone ?? "",
                nick_name: contactInfo?.nick_name ?? "",
                location: contactInfo?.location ?? "",
                alt_email: contactInfo?.alt_email ?? "",
                company_name: contactInfo?.company_name ?? "",
                company_phone: contactInfo?.company_phone ?? "",
                company_fax: contactInfo?.company_fax ?? "",
                company_address: contactInfo?.company_address ?? "",
                sip_uri: contactInfo?.sip_uri ?? "",
                custom_fields: []
            })

        }

    }, [contactInfo, editFlag, reset])

    const onsubmit = async (data) => {
        let updates = {};
        let saverep = {};
        if (editFlag) {
            if (dirtyFields) {
                let modifiedData = extractModifiedFields(dirtyFields, data);
                if (modifiedData) {
                    modifiedData.reqid = 112;
                    modifiedData.siteid = JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid;
                    modifiedData.id = parseInt(contactInfo.id);
                    setIsloading(true);
                    saverep = await updateAccContacts(modifiedData);
                }

            }
        } else {
            const hasRequiredFields =
                data.first_name || data.last_name || data.email || data.alt_email;
            if (!isDirty || !hasRequiredFields) {
                setError("first_name", {
                    type: "manual",
                    message: "Please provide at least First Name, Last Name, Email, or Alt Email.",
                });
                return;
            }

            if (isDirty) {
                updates = extractModifiedFields(dirtyFields, data);
                updates.reqid = 111;
                updates.contact_type = data.contact_type != 1 ? 4 : data.contact_type;
                updates.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            }
            setIsloading(true);
            saverep = await createAccContacts(updates);
        }
        console.log(`reponse of createAccContacts :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of createAccContacts after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            onClose();

            // window.location.href = "/contactslanding";
            navigate("/contactslanding", {
                state: { tab: "tab1" },
            });
            window.location.reload();
          
        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            }

        }
    }

    function extractModifiedFields(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }



    function handleSearchAddressChange(searchValue) {
        try {
            clearErrors("address");
            setValue("address", searchValue, { shouldDirty: true });
            if (typingTimeout) {
                clearTimeout(typingTimeout);
            }
            const newTimeout = setTimeout(() => {
                sendApIRequest(searchValue);
            }, 500);
            // Update the typingTimeout state with the new timeout
            setTypingTimeout(newTimeout);
        } catch (error) {
            console.log(`Error in handleSearchAddressChange :::: ${error}`);
        }
    }

    const sendApIRequest = async (searchValue) => {
        try {
          if (searchValue.trim() !== "" && allowAPI.current) {
            //if (searchValue.trim() !== "") {
            let update = {
              reqid: 84,
              search: searchValue,
              siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            };
            setIsLoading(true);
            console.log("Request for the search :::::: " + JSON.stringify(update));
            const serverResponse = await LocAddressSeach(update);
            setIsLoading(false);
            if (!serverResponse.ok) {
              console.log("Network response was not ok");
              throw new Error("Network response was not ok");
            } else {
              const responseData = await serverResponse.json();
              console.log("Response Data:", JSON.stringify(responseData));
              let addressList = responseData?.message?.suggestions ?? [];
              setAddressReasults(addressList);
              if (addressList.length === 0) {
                setisDisplay(false);
              } else {
                setisDisplay(true);
              }
            }
          } else {
            allowAPI.current = true;
            setisDisplay(false);
          }
        } catch (error) {
          console.log(`Error in sendApIRequest for address search :::: ${error}`);
        }
      };
      function handleAddressSelect(address) {
        if (address.street_line) {
          // setaddressValue(address.street_line);
          setValue("address", address.street_line, {
            shouldDirty: true,
          });
        }
          if (address.secondary) {
              setValue("address.loc_addr.street_addr2", address.secondary, {
                  shouldDirty: true,
              });
          } else {
              setValue("address.loc_addr.street_addr2", "", {
                  shouldDirty: true,
              });
          }
        if (address.city) {
          setValue("address.loc_addr.city", address.city, { shouldDirty: true });
        }
        // if (address.state) {
        //   const stateObj = states.find(
        //     (state) => state.statecode.trim() === address.state.trim()
        //   );
        //   console.log("stateObj :::::::: " + JSON.stringify(stateObj));
        //   if (stateObj) {
        //     setValue("address.loc_addr.state", stateObj.sid, {
        //       shouldDirty: true,
        //     });
        //   }
        // }
        if (address.zipcode) {
          setValue("address.loc_addr.zip", address.zipcode, { shouldDirty: true });
        }
      }
    return (
        <>
            <MDBRow>
                <MDBCol>
                    <div className="tel-numbers">
                        <strong>{t("firstName")}</strong>
                    </div>
                    <div className="form pt-1 w-100"><input maxLength={30} type="text" className="w-100 form-control" {...register("first_name")} />
                        {errors.first_name && (
                            <p className="text-danger">{errors.first_name.message}</p>
                        )}</div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("Nick Name")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input maxLength={30} type="text" className="w-100 form-control" {...register("nick_name")} />
                        {errors.nick_name && (
                            <p className="text-danger">{errors.nick_name.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("Alternate Email")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("alt_email", {
                            setValueAs: (value) => value?.trim(),
                           pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address",
                            },
                        })} />
                        {errors.alt_email && (
                            <p className="text-danger">{errors.alt_email.message}</p>
                        )}
                    </div>

                    <div className="tel-numbers mt-2">
                        <strong>{t("location")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("location")} />
                        {errors.location && (
                            <p className="text-danger">{errors.location.message}</p>
                        )}
                    </div>
                </MDBCol>


                <MDBCol>
                    <div className="tel-numbers">
                        <strong>{t("lastName")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input maxLength={20} type="text" className="w-100 form-control" {...register("last_name")} />
                        {errors.last_name && (
                            <p className="text-danger">{errors.last_name.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("email_address")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("email", {
                            setValueAs: (value) => value?.trim(),
                             pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address",
                            },
                        })} />
                        {errors.email && (
                            <p className="text-danger">{errors.email.message}</p>
                        )}
                    </div>

                    <div className="tel-numbers mt-2">
                        <strong>{t("sip_uri")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("sip_uri")} />
                        {errors.sip_uri && (
                            <p className="text-danger">{errors.sip_uri.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("notes")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("notes")} />
                        {errors.notes && (
                            <p className="text-danger">{errors.notes.message}</p>
                        )}
                    </div>
                </MDBCol>
            </MDBRow>
            <div className="tel-numbers mt-2">
                <strong>{t("currentAddressLoc")}</strong>
            </div>
            <div className="form pt-1 w-100">
                {/* <input type="text" className="w-100 form-control" {...register("address", { required: "Current Address Location is required" })} /> */}

                <MDBAutocomplete
                    data={addressReasults}
                    // value={addressValue}
                    value={watch("address")}
                    displayValue={(address) => address.street_line}
                    isLoading={isLoading}
                    // open={isDisplay}
                    placeholder="Address 1"
                    onSearch={handleSearchAddressChange}
                    onSelect={(e) => {
                        allowAPI.current = false;
                        setisDisplay(false);
                    }}
                    itemContent={(address) => (
                        <div
                            onClick={(e) => {
                                e.preventDefault();
                                allowAPI.current = false;
                                handleAddressSelect(address);
                            }}
                        >
                            {address.country &&
                                <img src={address.country === "USA" ? USA : CANADA} className='me-3' width={25} />
                            }
                            {address.street_line || ""}
                            {address.secondary ? ", " + address.secondary : ""}
                            {address.city ? ", " + address.city : ""}
                            {address.state ? ", " + address.state : ""}
                            {address.zipcode ? ", " + address.zipcode : ""}
                        </div>
                    )}
                />
                {errors.address && (
                    <p className="text-danger">{errors.address.message}</p>
                )}
            </div>
            <MDBRow>
                <MDBCol>
                    <div className="tel-numbers mt-2">
                        <strong>{t("companyName")}</strong>
                    </div>
                    <div className="form pt-1 w-100"><input maxLength={50} type="text" className="w-100 form-control" {...register("company_name")} />
                        {errors.company_name && (
                            <p className="text-danger">{errors.company_name.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("companyfax")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("company_fax")} />
                        {errors.company_fax && (
                            <p className="text-danger">{errors.company_fax.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("HomePhone")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("home_phone", 
                          
                        )} />
                        {errors.home_phone && (
                            <p className="text-danger">{errors.home_phone.message}</p>
                        )}
                    </div>
                    {JSON.parse(sessionStorage.getItem("admin_session"))?.logined_user?.includes("@") && (
                        <>
                            <div className="tel-numbers mt-2">
                                <strong>{t("contactype")}</strong>
                            </div>
                            <div className="form pt-1 w-100">
                                <select
                                    className="form-control form-select selectname"
                                    value={parseInt(watch("contact_type"))}
                                    onChange={(e) =>
                                        setValue("contact_type", parseInt(e.target.value), {
                                            shouldDirty: true,
                                        })
                                    }
                                >
                                    {contactType &&
                                        Object.entries(contactType).map(([key, value]) => (
                                            <option value={value}>{key}</option>
                                        ))}
                                </select>
                                {errors.contact_type && (
                                    <p className="text-danger">{errors.contact_type.message}</p>
                                )}
                            </div>
                        </>
                    )} 
                </MDBCol>


                <MDBCol>
                    <div className="tel-numbers mt-2">
                        <strong>{t("companyPhone")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("company_phone")} />
                        {errors.company_phone && (
                            <p className="text-danger">{errors.company_phone.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("MobilePhone")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("mobile_phone",
                           
                        )} />
                        {errors.mobile_phone && (
                            <p className="text-danger">{errors.mobile_phone.message}</p>
                        )}
                    </div>
                    <div className="tel-numbers mt-2">
                        <strong>{t("officePhone")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" {...register("office_phone",

                        )} />
                        {errors.office_phone && (
                            <p className="text-danger">{errors.office_phone.message}</p>
                        )}
                    </div>
                </MDBCol>
                { customFields?.length > 0 && <>
                <hr className='my-3' />
                <h5>Custom Fields</h5>
                <MDBCol>
                    {customFields.map((field) => (
                        <>
                            <div className="tel-numbers mt-2">
                                <strong>{field.label}</strong>
                            </div>
                            {field.ftype === 1  || field.field_type === 1? (
                                <div className="form pt-1 w-100">
                                    <input type="text" className="w-100 form-control"                                    
                                          defaultValue={field.value || ""}
                               onChange={(e) => handleCustomFields(e, field.field_id ?? field.id)} />
                                </div>
                            ) : (
                                <div className="form pt-1 w-100">
                                    <textarea
                                        className="w-100 form-control"                 
                                        defaultValue={field.value || ""}
                                        onChange={(e) => handleCustomFields(e, field.field_id ?? field.id)}
                                    />
                                </div>
                            )}
                        </>

                    ))} 
                </MDBCol>
                </> 
                }
            </MDBRow>
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>

            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}


        </>
    )
});

export default AddAccContacts
